import type { ConnectionState } from "ably";
import { isOneOf } from "@remi/ts-utils";
import { InactiveAblyConnectionStateValues } from "@remi/types-enums/ablyConnectionState";

export const isAblyConnectionStateActive = (connectionState: ConnectionState) => {
  return !isOneOf(connectionState, InactiveAblyConnectionStateValues);
};
